import apiCentralSeguranca from '@/api/centralseguranca';

export default {

  state : {   
    user: localStorage.getItem(process.env.VUE_APP_CLIENT_ID) || '',
    status: '',
    cidadao : ''
  },

  mutations : {
    authRequest(state) {
      state.status = 'loading';
    },
    authSuccess(state, payload) {
      state.status = 'success';
      state.user = payload;
    },
    authError(state) {
      state.status = 'error';
    },
    authLogout(state) {
      state.status = '';
      state.user = '';
    },
    limparUserState(state){
      state.user = '';
      localStorage.removeItem(process.env.VUE_APP_CLIENT_ID);
      
    },
    setCidadao(state,cidadao){
      state.cidadao = cidadao;
    },
    limparCidadao(state){
      state.cidadao = '';
    }
  },

  getters : {
    isAuthenticated(state) { 
      if(state.user == '') {
        return false;    
      } 
      if(JSON.parse(state.user).token.access_token) {
        return true;
      }
    },
    authStatus(state) {
      return state.status;
    },
    getUser(state) {
      return state.user;
    },
    getCidadao(state) {
      return state.cidadao;
    }
  },

  actions : {
    async authFilter({commit})  {
      return new Promise((resolve, reject) => {      
        commit('authRequest');
        let token = null;
        const userKey = process.env.VUE_APP_CLIENT_ID;      
        const user = localStorage.getItem(userKey);
        const userData = JSON.parse(user);
        
        if(user && userData && userData.token){
          token = userData.token.access_token;    
        } else {
          token = apiCentralSeguranca.getHashValue('access_token');
        }
      
        if(token != null) {
          apiCentralSeguranca.getInfoToken(token).then(res => {
            const dados = JSON.stringify({ token: res.data });
            localStorage.setItem(userKey, dados);          
            commit('authSuccess', dados);
            resolve(true);
          }).catch( (e) => {
            localStorage.removeItem(userKey);
            commit('authError');                    
            reject(false);
            window.location.href = ''+apiCentralSeguranca.authorizeUrl;
          });
        } else {        
          reject(false);
          window.location.href = ''+apiCentralSeguranca.authorizeUrl;
        }

      })
    },
    authLogout({commit}) {
      return new Promise((resolve) => {
        commit('authLogout');
        localStorage.removeItem("user");
        window.getApp.$router.push('/');
        resolve();
      })
    },
    obterCidadao({commit,getters}){
      if (getters.getCidadao == '') {
        let dados = '';
        apiCentralSeguranca.getInformacoesCidadao((JSON.parse(getters.getUser).token.access_token))
        .then(res => {
          dados = res.data;
          commit('setCidadao', dados);
        }).catch( () => {  
          //reject(false);
        });
        return dados;
      } else{
        return getters.getCidadao;
      }
    }
  }
}